import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SideNav } from 'app-components';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { configs } from '@constants/configs/configs';
import { useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';
import { HISTORICAL_PAGE_TYPE, HistoricalPageType } from './constants';

interface IHistoricalSideNavProps {
    page: HistoricalPageType;
}

const HistoricalSideNav: React.FC<IHistoricalSideNavProps> = ({ page }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const referenceId = searchParams.get('referenceId') ?? '';
    const showHistoricalLinking = useAppSelector(environmentSelector)?.showHistoricalLinking;

    const handleNavigation = (path: string) => {
        const query = searchParams.toString();
        navigate(query ? `${path}?${query}` : path);
    };

    return (
        <aside className="desktop:grid-col-3" id="gi-sidebar" data-testid="gi-sidebar">
            <SideNav key={page}>
                <SideNav.Header labelId="common.about_customer" />
                <SideNav.Item>
                    <SideNav.ActionLink
                        isSelectedDefault={page === HISTORICAL_PAGE_TYPE.BASIC_INFO}
                        labelId="admin.member.view.side.nav.basic_information"
                        onClickHandler={() => handleNavigation(configs.routes.CAP_MEMBER_HISTORICAL_APPLICANTS)}
                    />
                    <SideNav.ActionLink
                        isSelectedDefault={page === HISTORICAL_PAGE_TYPE.APPLICATIONS}
                        labelId="admin.member.view.side.nav.application"
                        onClickHandler={() => handleNavigation(configs.routes.CAP_MEMBER_HISTORICAL_APPLICATIONS)}
                    />
                    <SideNav.ActionLink
                        isSelectedDefault={page === HISTORICAL_PAGE_TYPE.ENROLLMENTS}
                        labelId="admin.member.view.side.nav.enrollments"
                        onClickHandler={() => handleNavigation(configs.routes.CAP_MEMBER_HISTORICAL_ENROLLMENTS)}
                    />
                    <ConditionalRendering isTrue={Boolean(showHistoricalLinking) && Boolean(referenceId)}>
                        <SideNav.ActionLink
                            isSelectedDefault={page === HISTORICAL_PAGE_TYPE.DOCUMENTS}
                            labelId="admin.member.view.side.nav.historicalDocuments"
                            onClickHandler={() => handleNavigation(configs.routes.CAP_MEMBER_HISTORICAL_DOCUMENTS)}
                        />
                        <SideNav.ActionLink
                            isSelectedDefault={page === HISTORICAL_PAGE_TYPE.NOTICES}
                            labelId="admin.member.view.side.nav.historicalNotices"
                            onClickHandler={() => handleNavigation(configs.routes.CAP_MEMBER_HISTORICAL_NOTICES)}
                        />
                    </ConditionalRendering>
                </SideNav.Item>
            </SideNav>
        </aside>
    );
};

export default HistoricalSideNav;

